import React from 'react';
import PropTypes from 'prop-types';
import { PersonFillIcon } from '../../../../model/icons';
import { participantName } from './participantsUtils';

// Карточка участника (.sp-partcard): аватар, команда, баланс/всего заработано. Клик открывает модалку с деталями.
export default function ParticipantCard({ participant, index, onSelect }) {
    const { teamName, teamColor, balance, totalBalance, achieveDailyPresent } = participant;

    return (
        <button type="button" className="sp-partcard" onClick={() => onSelect(participant)}>
            <span className="sp-pc-rank">{index + 1}</span>
            <span className="sp-pc-avatar" style={{ background: teamColor || 'var(--navy)' }}><PersonFillIcon /></span>
            <div className="sp-pc-name">{participantName(participant)}</div>
            {teamName && (
                <div className="sp-part-team"><span className="bdot" style={{ background: teamColor || 'var(--line-2)' }} />{teamName}</div>
            )}
            <div className="sp-bal-row">
                <span className="sp-bal now"><span className="l">Баланс</span><span className="v">{balance ?? 0}</span></span>
                <span className="sp-bal total"><span className="l">Всего заработано</span><span className="v">{totalBalance ?? 0}</span></span>
            </div>
            <span className="sp-badge done">Участие подтверждено</span>
            {achieveDailyPresent && <span className="sp-part-daily">бонус дня</span>}
        </button>
    );
}

ParticipantCard.propTypes = {
    participant: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        username: PropTypes.string,
        name: PropTypes.string,
        surname: PropTypes.string,
        teamName: PropTypes.string,
        teamColor: PropTypes.string,
        balance: PropTypes.number,
        totalBalance: PropTypes.number,
        achieveDailyPresent: PropTypes.bool
    }).isRequired,
    index: PropTypes.number.isRequired,
    onSelect: PropTypes.func.isRequired
};
